import type { SVGProps } from 'react';

import { Icon } from './Icon';

export function AutoAwesomeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <path
        d="m7.5 17.5-1.583-3.417L2.5 12.5l3.417-1.583L7.5 7.5l1.583 3.417L12.5 12.5l-3.417 1.583L7.5 17.5Zm0-2.917.667-1.416 1.416-.667-1.416-.667L7.5 10.417l-.667 1.416-1.416.667 1.416.667.667 1.416ZM13.333 10l-1.041-2.292L10 6.667l2.292-1.042L13.333 3.333l1.042 2.292L16.667 6.667l-2.292 1.041L13.333 10Z"
        fill="currentColor"
      />
    </Icon>
  );
}
